export const types = {
  set: 'SET_SEARCH_QUERY_MESSAGES',
  unset: 'UNSET_SEARCH_QUERY_MESSAGES'
} as const

export function setSearchQueryMessages(
  page?: string,
  kaiin_no?: string,
  name?: string,
  affiliation?: string,
  message?: string,
  unread?: boolean,
  user_unread?: boolean,
  messagefilter?: string,
  unreadfilter?: string,
  user_unreadfilter?: string
) {
  return {
    type: types.set,
    payload: {
      page,
      kaiin_no,
      name,
      affiliation,
      message,
      unread,
      user_unread,
      messagefilter,
      unreadfilter,
      user_unreadfilter
    }
  }
}
export function unsetSearchQueryMessages() {
  return { type: types.unset }
}
